import React from 'react'

export const Header = () => {
    return (
        <h2 className="text-gold">
            <small className="block text-muted">Arved</small>Отслеживание расходов
        </h2>
    )
}
